<template>
  <ValidationObserver v-slot="{ handleSubmit }" slim>
    <form class="p-3" @submit.prevent="handleSubmit(onSubmit)">
      <BaseInput
        v-model="formData.coverholder"
        :size="$props.size"
        label="Coverholder"
        rules="required"
      />

      <div class="mt-3 d-flex align-items-center justify-content-between">
        <BaseButton
          variant="outline-primary"
          :size="$props.size"
          @click="() => $emit('cancel')"
          >Cancel</BaseButton
        >
        <BaseButton :loading="isSubmitting" :size="$props.size" type="submit"
          >Save</BaseButton
        >
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { defineComponent, ref } from '@vue/composition-api'
import { ValidationObserver } from 'vee-validate'
import { uniqueId } from 'lodash-es'

import { BS_SIZES } from '@constants'
import { useTryCatch, useToast } from '@composables'

import { BaseInput, BaseButton } from '@components/base'

export default defineComponent({
  name: 'BDXNewCoverholderForm',
  components: {
    ValidationObserver,

    BaseInput,
    BaseButton
  },
  props: {
    size: {
      type: String,
      default: BS_SIZES.md,
      validator: (value) => BS_SIZES.includes(value)
    }
  },
  emits: ['success', 'cancel'],
  setup(_, { emit }) {
    const { showToast } = useToast()

    const isSubmitting = ref(false)

    const formData = ref({})

    const onSubmit = async () => {
      isSubmitting.value = true

      await useTryCatch(async () => {
        emit('success', {
          id: `new:${uniqueId()}:${formData.value.coverholder}`,
          coverholder: formData.value.coverholder,
          isNew: true
        })

        showToast('New Coverholder added successfully')
      })

      isSubmitting.value = false
    }

    return {
      isSubmitting,

      formData,

      onSubmit
    }
  }
})
</script>
